"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorIcon = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function ErrorIcon() {
    return (react_1.default.createElement("svg", { height: 32, width: 32, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", style: { display: 'block' } },
        react_1.default.createElement("g", { fill: core_ui_1.colors.fire[500] },
            react_1.default.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" }))));
}
exports.ErrorIcon = ErrorIcon;
